export default __webpack_public_path__ + "static/media/flower2.0afe2c0e.svg";